module.exports = __webpack_public_path__ + "static/media/sts.a967565c.jpg";